import { PRODUCTION_PURCHASE_REQUEST, CREATE_PRODUCTION_PURCHASE, GET_PRODUCTION_PURCHASES, UPDATE_PRODUCTION_PURCHASE, DELETE_PRODUCTION_PURCHASE, PRODUCTION_PURCHASE_FAILURE } from '../types';

const initialState = {
  productions: [],
  loading: false,
  error: null,
};

const productionPurchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTION_PURCHASE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PRODUCTION_PURCHASES: {
      return {
        ...state,
        productions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_PRODUCTION_PURCHASE:
      return {
        ...state,
        productions: [action.payload, ...state.productions],
        loading: false,
        error: null
      };
    case UPDATE_PRODUCTION_PURCHASE:
      const productionsData = state.productions.slice(0);
      const uIndex = productionsData.findIndex((data) => data.id === action.payload.id);
      productionsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        productions: [ ...productionsData ],
        loading: false,
        error: null
      };
    case DELETE_PRODUCTION_PURCHASE:
      const productions = state.productions?.slice(0);
      const index = productions.findIndex((data) => data.id === action.id);
      if (index > -1) {
        productions.splice(index, 1);
      }
      return {
        ...state,
        productions: [...productions],
        loading: false,
        error: null
      }
    case PRODUCTION_PURCHASE_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default productionPurchaseReducer;
